import React from 'react';
import { Link } from 'gatsby';
import sidebarImage from "../../../../content/contrast/react/components/images/sidebar.gif";
import sidebarImg from "../../../../content/contrast/react/components/images/sidebar.png";
export default {
  React,
  Link,
  sidebarImage,
  sidebarImg
};